var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarkSavedWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/book-saved"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/book-saved_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-saved"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.3763 5.00023V16.5919C9.3763 17.1836 8.7763 17.5919 8.23464 17.3669C6.68464 16.7169 4.75964 16.1502 3.39297 15.9669L3.13464 15.9336C2.3263 15.8336 1.66797 15.0919 1.66797 14.2836V4.37523C1.66797 3.37523 2.4763 2.56689 3.4763 2.56689H3.53464C5.1013 2.70023 7.40964 3.43356 8.93464 4.25856C9.20964 4.40856 9.3763 4.68356 9.3763 5.00023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.525 2.56689H16.475C16.275 2.58356 16.0583 2.60856 15.8333 2.65023C14.8083 2.81689 13.5917 3.16689 12.5 3.60023C11.9833 3.80856 11.5 4.03356 11.075 4.25856C10.8 4.40856 10.625 4.69189 10.625 5.00023V16.5919C10.625 17.1836 11.225 17.5919 11.7667 17.3669C13.3167 16.7169 15.2417 16.1502 16.6083 15.9669L16.8667 15.9336C17.675 15.8336 18.3333 15.0919 18.3333 14.2836V4.37523C18.3333 3.37523 17.525 2.56689 16.525 2.56689ZM16.0583 9.44189C16.0583 9.76689 15.825 9.90856 15.5417 9.75023L14.6583 9.25856C14.5667 9.20856 14.4167 9.20856 14.3167 9.25856L13.4333 9.75023C13.15 9.90856 12.9167 9.76689 12.9167 9.44189C12.9167 9.44189 12.9167 6.42206 12.9167 5.79557C12.9167 5.16908 13.5 5 13.5 5C13.5 5 14.1201 4.75503 15 4.5C15.8333 4.25847 16.0583 4.6637 16.0667 4.88356L16.0583 9.44189Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkSavedWhite);
export default __webpack_public_path__ + "static/media/bookmark-saved-white.82123f60318aaa0a60815b8c8bfa7b30.svg";
export { ForwardRef as ReactComponent };